// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ServiceFeesForm-space1-nrQr3 {
	margin-bottom: 6px !important;
}

.ServiceFeesForm-space2-FqAqS {
	margin-bottom: 12px !important;
}

.ServiceFeesForm-space3-mPBwT {
	margin-bottom: 18px !important;
}

.ServiceFeesForm-space4-vSwcR {
	margin-bottom: 24px !important;
}

.ServiceFeesForm-space5-Wgq7M {
	margin-bottom: 30px !important;
}

.ServiceFeesForm-space6-Sb3Og {
	margin-bottom: 36px !important;
}

.ServiceFeesForm-space7-noNMt {
	margin-bottom: 42px !important;
}

.ServiceFeesForm-space8-HE8j4 {
	margin-bottom: 48px !important;
}

.ServiceFeesForm-spaceTop1-EuHfi {
	margin-top: 6px !important;
}

.ServiceFeesForm-spaceTop2-xda6Z {
	margin-top: 12px !important;
}

.ServiceFeesForm-spaceTop3-jBep5 {
	margin-top: 18px !important;
}

.ServiceFeesForm-spaceTop4-pi07H {
	margin-top: 24px !important;
}

.ServiceFeesForm-spaceTop5-G7EXl {
	margin-top: 30px !important;
}

.ServiceFeesForm-spaceTop6-pXIhs {
	margin-top: 36px !important;
}

.ServiceFeesForm-spaceTop7-EI3yi {
	margin-top: 42px !important;
}

.ServiceFeesForm-spaceTop8-ajjHs {
	margin-top: 48px !important;
}

.ServiceFeesForm-noMargin-nujOE {
	margin: 0px !important;
}

.ServiceFeesForm-padding1-Dy9Du {
	padding-bottom: 6px !important;
}

.ServiceFeesForm-padding2-kbjef {
	padding-bottom: 12px !important;
}

.ServiceFeesForm-padding3-jVef6 {
	padding-bottom: 18px !important;
}

.ServiceFeesForm-padding4-HMCD4 {
	padding-bottom: 24px !important;
}

.ServiceFeesForm-padding5-d4Pm6 {
	padding-bottom: 30px !important;
}

.ServiceFeesForm-padding6-AATjN {
	padding-bottom: 36px !important;
}

.ServiceFeesForm-padding7-zi_te {
	padding-bottom: 42px !important;
}

.ServiceFeesForm-paddingTop1-ZB2Id {
	padding-top: 6px !important;
}

.ServiceFeesForm-paddingTop2-rK1WV {
	padding-top: 12px !important;
}

.ServiceFeesForm-paddingTop3-j0m4Q {
	padding-top: 18px !important;
}

.ServiceFeesForm-paddingTop4-WToai {
	padding-top: 24px !important;
}

.ServiceFeesForm-paddingTop5-YpEjC {
	padding-top: 30px !important;
}

.ServiceFeesForm-paddingTop6-GgkRD {
	padding-top: 36px !important;
}

.ServiceFeesForm-paddingTop7-A1IJJ {
	padding-top: 42px !important;
}

.ServiceFeesForm-noPadding-NAjLQ {
	padding: 0px !important;
}

.ServiceFeesForm-spaceMarginBottom0-o2Cci {
	margin-bottom: 0;
}

.ServiceFeesForm-textBold-ZF_UL {
	font-weight: 500 !important;
}

.ServiceFeesForm-textBolder-D8GvD {
	font-weight: 700 !important;
}

.ServiceFeesForm-textNormal-zSXC1 {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ServiceFeesForm-textDarkBlue-j9YPZ {
	color: rgb(20, 39, 94) !important;
}

.ServiceFeesForm-textLightBlue-Ou4f4 {
	color: rgb(57, 87, 106) !important;
}

.ServiceFeesForm-textLightSandleGreen-mqFcT {
	color: rgb(76, 86, 41) !important;
}

.ServiceFeesForm-textLightBrown-xezjH {
	color: rgb(115, 79, 33) !important;
}

.ServiceFeesForm-textMediumMaroon-Syx2c {
	color: rgb(87, 37, 51) !important;
}

.ServiceFeesForm-textBrown-nHzeT {
	color: rgb(160, 47, 24) !important;
}

.ServiceFeesForm-textMaroon-PiuEz {
	color: rgb(155, 49, 67) !important;
}

.ServiceFeesForm-textDarkBrown-DfJZc {
	color: rgb(83, 18, 16) !important;
}

.ServiceFeesForm-textMediumBrown-jivyx {
	color: rgb(142, 28, 10) !important;
}

.ServiceFeesForm-textSkyBlue-c6CA_ {
	color: rgb(37, 117, 141) !important;
}

.ServiceFeesForm-textGray-_2QKO {
	color: rgb(77, 65, 51) !important;
}

.ServiceFeesForm-errorMessage-W0Czk {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ServiceFeesForm-userText-vMLPH {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ServiceFeesForm-panelHeader-OtoRj {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ServiceFeesForm-exportSection-dp1qB {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ServiceFeesForm-exportSectionGridSub-Hqvhq {
	grid-template-columns: 50% 49% !important;
}

.ServiceFeesForm-exportText-KVfB8 {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ServiceFeesForm-exportLinkImg-tcmHw {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ServiceFeesForm-exportImg-tdbPT {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ServiceFeesForm-linkBtn-jgN78 {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ServiceFeesForm-table-n4WmV {
	display: table;
}

.ServiceFeesForm-tableRow-_rYoR {
	display: table-row;
}

.ServiceFeesForm-tableCell-NUW77 {
	display: table-cell;
	float: none;
}

.ServiceFeesForm-formGroup-_A6gl {
	margin-bottom: 6px;
}

.ServiceFeesForm-marginTop0-VszXB {
	margin-top: 0;
}

.ServiceFeesForm-marginBottom20-fYWxl {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ServiceFeesForm-bannerImageBg-U12uc {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ServiceFeesForm-bannerDelete-ZJZ07 {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ServiceFeesForm-exportLink-p3WkR {
	padding-top: 10px;
	padding-right: 10px;
}

.ServiceFeesForm-seachContent-a68iJ {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ServiceFeesForm-marginBottom9-bbS04 {
	margin-bottom: 9px;
}

.ServiceFeesForm-spaceTop52-QNVLY {
	margin-top: 52px;
}

.ServiceFeesForm-profileViewInner-J1oWy {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ServiceFeesForm-profileViewMain-n_fmV {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ServiceFeesForm-profileViewlabel-vfAel {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ServiceFeesForm-profileViewMainContent-p9xCk {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ServiceFeesForm-reviewsFormStar-tHD6d {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ServiceFeesForm-reviewsFormStar-tHD6d svg {
	cursor: pointer;
}

.ServiceFeesForm-addLanguageText-mQE5U {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ServiceFeesForm-exportSection-dp1qB {
		grid-template-columns: 100%;
	}

	.ServiceFeesForm-spaceTop52-QNVLY {
		margin-top: 18px;
	}

	.ServiceFeesForm-exportText-KVfB8 {
		float: none;
		margin-top: 12px;
	}

	.ServiceFeesForm-exportSectionGridSub-Hqvhq {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ServiceFeesForm-profileViewlabel-vfAel {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ServiceFeesForm-profileViewMainContent-p9xCk {
		width: 100%;
		text-align: center;
	}

	.ServiceFeesForm-panelHeader-OtoRj {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.ServiceFeesForm-cardHeader-JpWhL {
    padding: 18px 24px;
    border-bottom: 1px solid var(--primary-border);
}

.ServiceFeesForm-cardBodyStyle-PzBPA {
    padding: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/ServiceFeesForm/ServiceFeesForm.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;IACI,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n\n.cardHeader {\n    padding: 18px 24px;\n    border-bottom: 1px solid var(--primary-border);\n}\n\n.cardBodyStyle {\n    padding: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ServiceFeesForm-space1-nrQr3`,
	"space2": `ServiceFeesForm-space2-FqAqS`,
	"space3": `ServiceFeesForm-space3-mPBwT`,
	"space4": `ServiceFeesForm-space4-vSwcR`,
	"space5": `ServiceFeesForm-space5-Wgq7M`,
	"space6": `ServiceFeesForm-space6-Sb3Og`,
	"space7": `ServiceFeesForm-space7-noNMt`,
	"space8": `ServiceFeesForm-space8-HE8j4`,
	"spaceTop1": `ServiceFeesForm-spaceTop1-EuHfi`,
	"spaceTop2": `ServiceFeesForm-spaceTop2-xda6Z`,
	"spaceTop3": `ServiceFeesForm-spaceTop3-jBep5`,
	"spaceTop4": `ServiceFeesForm-spaceTop4-pi07H`,
	"spaceTop5": `ServiceFeesForm-spaceTop5-G7EXl`,
	"spaceTop6": `ServiceFeesForm-spaceTop6-pXIhs`,
	"spaceTop7": `ServiceFeesForm-spaceTop7-EI3yi`,
	"spaceTop8": `ServiceFeesForm-spaceTop8-ajjHs`,
	"noMargin": `ServiceFeesForm-noMargin-nujOE`,
	"padding1": `ServiceFeesForm-padding1-Dy9Du`,
	"padding2": `ServiceFeesForm-padding2-kbjef`,
	"padding3": `ServiceFeesForm-padding3-jVef6`,
	"padding4": `ServiceFeesForm-padding4-HMCD4`,
	"padding5": `ServiceFeesForm-padding5-d4Pm6`,
	"padding6": `ServiceFeesForm-padding6-AATjN`,
	"padding7": `ServiceFeesForm-padding7-zi_te`,
	"paddingTop1": `ServiceFeesForm-paddingTop1-ZB2Id`,
	"paddingTop2": `ServiceFeesForm-paddingTop2-rK1WV`,
	"paddingTop3": `ServiceFeesForm-paddingTop3-j0m4Q`,
	"paddingTop4": `ServiceFeesForm-paddingTop4-WToai`,
	"paddingTop5": `ServiceFeesForm-paddingTop5-YpEjC`,
	"paddingTop6": `ServiceFeesForm-paddingTop6-GgkRD`,
	"paddingTop7": `ServiceFeesForm-paddingTop7-A1IJJ`,
	"noPadding": `ServiceFeesForm-noPadding-NAjLQ`,
	"spaceMarginBottom0": `ServiceFeesForm-spaceMarginBottom0-o2Cci`,
	"textBold": `ServiceFeesForm-textBold-ZF_UL`,
	"textBolder": `ServiceFeesForm-textBolder-D8GvD`,
	"textNormal": `ServiceFeesForm-textNormal-zSXC1`,
	"textDarkBlue": `ServiceFeesForm-textDarkBlue-j9YPZ`,
	"textLightBlue": `ServiceFeesForm-textLightBlue-Ou4f4`,
	"textLightSandleGreen": `ServiceFeesForm-textLightSandleGreen-mqFcT`,
	"textLightBrown": `ServiceFeesForm-textLightBrown-xezjH`,
	"textMediumMaroon": `ServiceFeesForm-textMediumMaroon-Syx2c`,
	"textBrown": `ServiceFeesForm-textBrown-nHzeT`,
	"textMaroon": `ServiceFeesForm-textMaroon-PiuEz`,
	"textDarkBrown": `ServiceFeesForm-textDarkBrown-DfJZc`,
	"textMediumBrown": `ServiceFeesForm-textMediumBrown-jivyx`,
	"textSkyBlue": `ServiceFeesForm-textSkyBlue-c6CA_`,
	"textGray": `ServiceFeesForm-textGray-_2QKO`,
	"errorMessage": `ServiceFeesForm-errorMessage-W0Czk`,
	"userText": `ServiceFeesForm-userText-vMLPH`,
	"panelHeader": `ServiceFeesForm-panelHeader-OtoRj`,
	"exportSection": `ServiceFeesForm-exportSection-dp1qB`,
	"exportSectionGridSub": `ServiceFeesForm-exportSectionGridSub-Hqvhq`,
	"exportText": `ServiceFeesForm-exportText-KVfB8`,
	"exportLinkImg": `ServiceFeesForm-exportLinkImg-tcmHw`,
	"exportImg": `ServiceFeesForm-exportImg-tdbPT`,
	"linkBtn": `ServiceFeesForm-linkBtn-jgN78`,
	"table": `ServiceFeesForm-table-n4WmV`,
	"tableRow": `ServiceFeesForm-tableRow-_rYoR`,
	"tableCell": `ServiceFeesForm-tableCell-NUW77`,
	"formGroup": `ServiceFeesForm-formGroup-_A6gl`,
	"marginTop0": `ServiceFeesForm-marginTop0-VszXB`,
	"marginBottom20": `ServiceFeesForm-marginBottom20-fYWxl`,
	"bannerImageBg": `ServiceFeesForm-bannerImageBg-U12uc`,
	"bannerDelete": `ServiceFeesForm-bannerDelete-ZJZ07`,
	"exportLink": `ServiceFeesForm-exportLink-p3WkR`,
	"seachContent": `ServiceFeesForm-seachContent-a68iJ`,
	"marginBottom9": `ServiceFeesForm-marginBottom9-bbS04`,
	"spaceTop52": `ServiceFeesForm-spaceTop52-QNVLY`,
	"profileViewInner": `ServiceFeesForm-profileViewInner-J1oWy`,
	"profileViewMain": `ServiceFeesForm-profileViewMain-n_fmV`,
	"profileViewlabel": `ServiceFeesForm-profileViewlabel-vfAel`,
	"profileViewMainContent": `ServiceFeesForm-profileViewMainContent-p9xCk`,
	"reviewsFormStar": `ServiceFeesForm-reviewsFormStar-tHD6d`,
	"addLanguageText": `ServiceFeesForm-addLanguageText-mQE5U`,
	"cardHeader": `ServiceFeesForm-cardHeader-JpWhL`,
	"cardBodyStyle": `ServiceFeesForm-cardBodyStyle-PzBPA`
};
module.exports = ___CSS_LOADER_EXPORT___;
